import AddIcon from '@mui/icons-material/Add';
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMyTickets } from '../api/hooks';

const OPEN_STATUSES = new Set(['New', 'Open', 'Pending', 'On Hold']);

export function MyTicketsPage() {
  const navigate = useNavigate();
  const { data, isLoading } = useMyTickets();

  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography variant="h1">My tickets</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/tickets/new')}>
          Raise a ticket
        </Button>
      </Stack>

      {isLoading ? (
        <Box sx={{ display: 'grid', placeItems: 'center', py: 6 }}>
          <CircularProgress />
        </Box>
      ) : data && data.items.length > 0 ? (
        <List sx={{ bgcolor: 'background.paper', borderRadius: 1 }}>
          {data.items.map((t) => (
            <ListItemButton key={t.id} divider onClick={() => navigate(`/tickets/${t.id}`)}>
              <ListItemText
                primary={`#${t.ticketNumber} · ${t.subject}`}
                secondary={`Updated ${new Date(t.updatedAt).toLocaleString()}`}
              />
              <Chip
                label={t.status}
                size="small"
                color={OPEN_STATUSES.has(t.status) ? 'primary' : 'default'}
              />
            </ListItemButton>
          ))}
        </List>
      ) : (
        <Typography color="text.secondary">
          You have no tickets yet. Raise one and we'll get onto it.
        </Typography>
      )}
    </Box>
  );
}
